export default function (state, getters, rootState, rootGeeters) {
  let url = '/tourclient/balanceSheet/createXLS?';
  url += 'DateFrom=' + state.dates[0] + '&';
  url += 'DateTo=' + state.dates[1] + '&';
  url += 'WithDocumens=' + state.WithDocumens + '&';
  url += 'WithTurns=' + state.WithTurns + '&';
  url += 'CurrencyId=' + (state.CurrencyId ? state.CurrencyId : '0') + '&';
  url += 'AccountId=' + (state.AccountId ? state.AccountId : '0') + '&';
  url += 'SubAccountId=' + (state.SubAccountId ? state.SubAccountId : '0') + '&';
  url += 'PartnerId=' + (state.ContragentId ? state.ContragentId : '0') + '&';
  url += 'PaymentAccountId=' + (state.PaymentAccountId ? state.PaymentAccountId : '0') + '&';
  url += 'ColumnsStr=3,4,5,6,7,8,12,15,16';
  rootState.balanceSheet.settings.columns.forEach(i => {
    if (i.name === 'Name' && i.visible) url += ',2';
    if (i.name === 'CurrencyName' && i.visible) url += ',9';
    if (i.name === 'RateName' && i.visible) url += ',10';
    if (i.name === 'PartnerName' && i.visible) url += ',13';
    if (i.name === 'PaymentAccount' && i.visible) url += ',14';
    if (i.name === 'DepartmentName' && i.visible) url += ',17';
  });
  url += '&';
  url += '_=' + new Date().getTime();
  return url;
}